import { Modal } from 'react-bootstrap';
import ExecutionLog from './ExecutionLog';

const ExecutionModal = ({ show, onHide ,size='xl',data}) => {
 
    return (
    <Modal show={show} backdrop="static" centered onHide={onHide} size={size}>
        <Modal.Header
                closeButton
                className="border-bottom-0 pe-3 align-items-center"
              >
                <Modal.Title
                  as="h3"
                  className="flex-grow-1 px-2 py-0 cursor-pointer flex-center font-fredoka fw-normal"
                >
                  Execution Logs
                </Modal.Title>
              </Modal.Header>
      <Modal.Body className="d-flex flex-column bg-body rounded-3 align-items-center w-100">
     <ExecutionLog reportId={data?.id}/>
      </Modal.Body>
    </Modal>
  );
};

export default ExecutionModal;
